import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

type PostReset2FAResponse = unknown;

export const usePostReset2FAMutation = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: PostReset2FAResponse) => void;
    onError?: (error: Error) => void;
  } = {
    onSuccess: undefined,
    onError: undefined,
  }
) => {
  return useMutation({
    mutationFn: async ({ email }: { email: string }) => {
      const { data } = await client.post(`/auth/2fa/totp/reset`, { email });

      return data;
    },
    onSuccess,
    onError,
  });
};
